export default {
  name: "hammer",
  class: "heroicon-tools heroicon heroicon-sm",
  box: 60,
  svg: `<path
  class="heroicon-tools-screwdriver-handle heroicon-component-accent heroicon-component-fill"
  d="M5 29h10v4l-1.5 2 1.5 2v17.99A4 4 0 0 1 10.99 59H9.01A4.01 4.01 0 0 1 5 54.99V37l2-2-2-2v-4z"
/>
<path
  class="heroicon-tools-hammer-handle heroicon-component-accent heroicon-component-fill"
  d="M42 14h-6l1 18.02-1.82 25.57a18.08 18.08 0 0 0 7.64 0L41 32.02 42 14z"
/>
<polygon
  class="heroicon-tools-screwdriver-head heroicon-component-fill"
  points="9 12 9 11.528 8.789 11.106 7.179 7.886 9.386 2 10.614 2 12.821 7.886 11.211 11.106 11 11.528 11 12 11 28 9 28"
/>
<path
  class="heroicon-tools-hammer-head heroicon-component-fill"
  d="M28 2v8h-3V2h3zm2 6V3.46A3.98 3.98 0 0 0 35.46 2H46a8 8 0 0 1 8 7.87 9 9 0 0 0-8.57-4.85l-1.5.1-.33 1.46L42.4 12h-6.74A6 6 0 0 0 30 8z"
/>
<path
  class="heroicon-shadows"
  d="M5 33h10l-2 2H7l-2-2zm3 6a2 2 0 1 1 4 0v15a2 2 0 1 1-4 0V39z"
/>
<path
  class="heroicon-outline"
  fill-rule="nonzero"
  d="M7 28V12L5 8l3-8h4l3 8-2 4v16h3v6l-1 1 1 1v19a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V36l1-1-1-1v-6h3zm6.59 8.41L12.17 35l1.42-1.41.41-.42V30H6v3.17l.41.42L7.83 35 6.4 36.41l-.41.42V55a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3V36.83l-.41-.42zM10 37a2 2 0 0 1 2 2v15a2 2 0 1 1-4 0V39c0-1.1.9-2 2-2zm1 17V39a1 1 0 1 0-2 0v15a1 1 0 1 0 2 0zM9 12v16h2V11.53l.21-.42 1.61-3.22L10.62 2H9.38L7.18 7.89l1.6 3.22.22.42V12zM25 0h5a2 2 0 1 0 4 0h12a10 10 0 0 1 10 10v2h-3.29a7 7 0 0 0-7.16-4.99L44 14l-1 18 1.94 27.1a20 20 0 0 1-11.88 0L35 32l-1-18a4 4 0 0 0-4-4 2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V2c0-1.1.9-2 2-2zm3 2h-3v8h3V2zm2 6a6 6 0 0 1 5.66 4h6.74l1.2-5.42.33-1.47 1.5-.1L46 5a9 9 0 0 1 8 4.87A8 8 0 0 0 46 2H35.46A4 4 0 0 1 30 3.46V8zm12 6h-6l1 18.02-1.82 25.57a18.08 18.08 0 0 0 7.64 0L41 32.02 42 14zm-3 2v39h1v1h-2V16h1z"
/>`,
};
